import type { ChatSource } from "@mirage/mosaics/Chat/types";
import { convertFssEntityToChatSource } from "@mirage/service-conversation/utils/convertFssEntityToChatSource";
import { useActionEvents } from "@mirage/service-fss-bridge/hooks/bridgeObservers";

import type { SetStateAction } from "react";
import { useEffect } from "react";

export const useFssConversationActions = (
  setManuallyAddedSources: (sources: SetStateAction<ChatSource[]>) => void,
) => {
  const actionEvent = useActionEvents("add.source");

  useEffect(() => {
    if (actionEvent && actionEvent.data) {
      const sources: ChatSource[] = actionEvent.data.sources.map((source) =>
        convertFssEntityToChatSource(source),
      );
      setManuallyAddedSources((prev) => [...prev, ...sources]);
    }
  }, [setManuallyAddedSources, actionEvent]);
};
